import {css} from 'aphrodite';
import React from 'react';

import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';

import AutomationFileConfigFileFormatInput from '../AutomationFileConfigFileFormatInput';
import {automationFileConfigStyles, SectionNumber} from '../AutomationFileConfigUtils';
import {
  ClientAutomationOutputFileConfigSpec,
  labAutomationFileDelimiterOptions,
} from '../RunSchemaSpecConstants';

interface AutomationOutputFileConfigEditorFormatSectionProps {
  onUpdateConfig: (newConfig: ClientAutomationOutputFileConfigSpec) => void;
  outputFileConfig: ClientAutomationOutputFileConfigSpec;
  /** Controls whether this is the last section in the list and if so, does not add a border */
  isLastSection: boolean;
  sectionNumber: number;
}

export default function AutomationOutputFileConfigEditorFormatSection(
  props: AutomationOutputFileConfigEditorFormatSectionProps
): JSX.Element {
  const outerClassName = props.isLastSection
    ? css(automationFileConfigStyles.subsection)
    : css(automationFileConfigStyles.subsection, automationFileConfigStyles.subsectionBorder);
  return (
    <div className={outerClassName}>
      <SectionNumber sectionNumber={props.sectionNumber} />
      <div className={css(automationFileConfigStyles.innerTitle)}>Configure delimiter</div>
      <div
        className={css(automationFileConfigStyles.description, automationFileConfigStyles.sectionDescription)}
      >
        Choose the delimiter used in your output files. (Can be safely ignored if your output files are Excel
        spreadsheets.)
      </div>
      <div className={css(automationFileConfigStyles.formatSectionContents)}>
        <div className={css(automationFileConfigStyles.formatSectionItem)}>
          <FieldLabel label="Delimiter" labelStyle={LabelStyle.LABEL} />
          <br />
          <AutomationFileConfigFileFormatInput
            label="Delimiter"
            options={labAutomationFileDelimiterOptions}
            value={props.outputFileConfig.delimiter}
            onSelect={(value: string) => {
              props.onUpdateConfig({
                ...props.outputFileConfig,
                delimiter: value,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
}
